import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild('loginForm') loginForm: NgForm;
  data: any;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit() { }
  onSubmit() {
    if (this.loginForm.valid) {
      this.authService.signinUser({ username: this.loginForm.value.name.toLowerCase(), password: this.loginForm.value.pass })
        .subscribe(resp => {
          this.data = resp;
          if (this.data.Result === 1) {
            this.authService.login(this.data.Result, this.loginForm.value.name.toLowerCase());
            return this.router.navigate(['/embaded-soft']);
          } else {
            swal('Vérifier vos identifiants de connexion!', '', 'error');
          }
        }, err => {
          // let msg = swal('une erreur s\'est produite lors de l\'authentification!', err.error.msg , 'error');
        });
    }
  }

}
